/* eslint-disable import/no-anonymous-default-export */
import environment from '../environments/Environment';
import HttpService from './HttpService';

export default {
    getDataCatalog() {
        return HttpService.get(environment.API_DATA_CATALOG);
    },
    changeDataCatalog(payload) {
        return HttpService.patch(environment.API_DATA_CATALOG, payload);
    },
    getDropDownDataCatalog() {
        return HttpService.get(environment.API_DROPDOWN_DATA_CATALOG);
    },
};
